import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  Checkbox,
} from "@mui/material";
import { CancelPresentation as CancelPresentationIcon } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
// import 'react-toastify/dist/ReactToastify.css';
// import { ToastContainer } from 'react-toastify';
import { useDialogueState } from "../../../Context/DialogueProvider";
import {
  getdrpRoomTypeMst,
  getdrpRoomView,
  getRoomMaster,
  manageRoomUpdation,
} from "../../../Api/RoomMst/Api";
import { deleteRoomMst } from '../../../Api/PropertyMst/Api'
import { toast } from "react-toastify";
import { getMstPropRoomConfigDashBoard } from "../../../Api/PropertyMst/Api";

export default function RoomMasterFormOneButton({ PropId, formMode, isEditable, refreshRoomData }) {
  const { dialogueState, handleDialogueToggle } = useDialogueState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const [roomType, setRoomType] = useState([]);
  const [roomView, setRoomView] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState(null);
  const [selectedRoomView, setSelectedRoomView] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [filterNullRoomTypeName, setFilterNullRoomTypeName] = useState(false);
  const [filterNullRoomView, setFilterNullRoomView] = useState(false);
  const [filterNullSqFt, setFilterNullSqFt] = useState(false);
  const [filterNullTotalBeds, setFilterNullTotalBeds] = useState(false);
  const [filterNullMonthlyRent, setFilterNullMonthlyRent] = useState(false);
  const [formData, setFormData] = useState({
    RoomTypeId: "",
    RoomViewId: "",
    SqFt: "",
    MonthlyRent: "",
    TotalBeds: "",
  });

  const columns = [
    // { id: "All", label: "All", minWidth: 10 },
    { id: "PropName", label: "Property", minWidth: 90 },
    { id: "WingName", label: "Wing", minWidth: 75 },
    { id: "FloorName", label: "Floor", minWidth: 60 },
    { id: "RoomNo", label: "R_No.", minWidth: 90 },
    {
      id: "RoomTypeName", label: (props) => (
        <Box>
          RType
          <Checkbox
            size="small"
            checked={filterNullRoomTypeName}
            onChange={(e) => setFilterNullRoomTypeName(e.target.checked)}
          />
        </Box>
      ), minWidth: 110
    },

    {
      id: "RoomViewNAme",
      label: (props) => (
        <Box>
          RView
          <Checkbox
            size="small"
            checked={filterNullRoomView}
            onChange={(e) => setFilterNullRoomView(e.target.checked)}
          />
        </Box>
      ),
      minWidth: 110
    },

    {
      id: "TotalBeds",
      label: (props) => (
        <Box>
          Tot.Beds
          <Checkbox
            size="small"
            checked={filterNullTotalBeds}
            onChange={(e) => setFilterNullTotalBeds(e.target.checked)}
          />
        </Box>
      ),
      minWidth: 100
    },
    {
      id: "SqFt",
      label: (props) => (
        <Box>
          SqFt
          <Checkbox
            size="small"
            checked={filterNullSqFt}
            onChange={(e) => setFilterNullSqFt(e.target.checked)}
          />
        </Box>
      ),
      minWidth: 10
    },
    {
      id: "MonthlyRent",
      label: (props) => (
        <Box>
          Rent
          <Checkbox
            size="small"
            checked={filterNullMonthlyRent}
            onChange={(e) => setFilterNullMonthlyRent(e.target.checked)}
          />
        </Box>
      ),
      minWidth: 50
    },
  ];

  const handleGenerateRooms = async () => {
    const response = await getMstPropRoomConfigDashBoard(PropId);

    if (response instanceof Error) {
      return toast.error("Error: Could not Generate Rooms");
    }

    const {
      data: { Status, Message, Data },
    } = response;

    if (Status === 0 && Message && Array.isArray(Data)) {
      await getRoomMasterData();
      refreshRoomData();
      toast.success("Rooms Generated Successfully...", {
        autoClose: 1000, // Optional: Auto-close toast after 1 second
        onClose: () => setIsModalOpen(false), // Close modal on toast close
      });

    } else {
      toast.error(Message || "Room generation failed.");
    }
  };

  useEffect(() => {
    console.log("isEditable updated:", isEditable);
  }, [isEditable])

  const getFlag = () => {
    if (formData.RoomTypeId && formData.RoomViewId) {
      return "";
    }

    if (!formData.RoomTypeId && formData.RoomViewId) {
      return "";
    }

    if (formData.RoomTypeId && !formData.RoomViewId) {
      return "";
    }
  };

  const getSubmitPayload = () => {
    const payload = selectedRows.map((roomId) => {
      const updatedRows = getUpdatedRows();
      const currentSelectedRow = updatedRows.find(
        (row) => row.RoomId === roomId
      );

      let value = {
        RoomId: currentSelectedRow.RoomId,
        RoomTypeId: currentSelectedRow.RoomTypeId,
        RoomViewId: currentSelectedRow.RoomViewId,
        Flag: getFlag(),
      };

      if (currentSelectedRow.SqFt) {
        value.SqFt = currentSelectedRow.SqFt;
      }

      if (currentSelectedRow.MonthlyRent) {
        value.MonthlyRent = currentSelectedRow.MonthlyRent;
      }

      if (currentSelectedRow.TotalBeds) {
        value.TotalBeds = currentSelectedRow.TotalBeds;
      }

      return value;
    });
    return {
      ManageRoomUpdation: payload,
    };
  };


  const getRoomTypeName = (id) => roomType.find((type) => type.Id === id);
  const getRoomViewName = (id) => roomView.find((type) => type.Id === id);

  const getUpdatedRows = () => {
    let newRows = [...rows];
    selectedRows.forEach((roomId) => {
      const currentSelectedRow = newRows.find((row) => row.RoomId === roomId);
      if (currentSelectedRow) {
        currentSelectedRow.RoomTypeId = formData.RoomTypeId;
        currentSelectedRow.RoomViewId = formData.RoomViewId;
        currentSelectedRow.RoomTypeName = getRoomTypeName(
          formData.RoomTypeId
        )?.Name;
        currentSelectedRow.RoomViewNAme = getRoomViewName(
          formData.RoomViewId
        )?.Name;
        currentSelectedRow.SqFt = formData.SqFt;
        currentSelectedRow.MonthlyRent = formData.MonthlyRent;
        currentSelectedRow.TotalBeds = formData.TotalBeds;
        newRows = newRows.filter((row) => row.RoomId !== roomId);
        newRows.push(currentSelectedRow);
      }
    });
    return newRows;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    (async () => {
      const response = await getdrpRoomTypeMst();
      if (response instanceof Error) {
        return toast.error(response.message);
      }
      const {
        data: { Status, responseStatusCode, Data },
      } = response;
      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        setRoomType(Data);
        if (Data.length > 0) {
          setFormData((prev) => ({ ...prev, RoomTypeId: Data[0].Id })); // Select the first index
        }
      } else {
        return toast.error("Error: RoomType not found");
      }
    })();
  }, []);

  const loadRoomViewData = async () => {
    const response = await getdrpRoomView();
    if (response instanceof Error) {
      return toast.error(response.message);
    }
    const { data: { Status, responseStatusCode, Data } } = response;
    if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
      setRoomView(Data);
      if (Data.length > 0) {
        setFormData((prev) => ({ ...prev, RoomViewId: Data[0].Id }));
      }
    } else {
      return toast.error("Error: Room View not found");
    }
  };

  const handleDelete = async () => {
    if (!PropId) {
      return toast.error("Property ID is required");
    }

    if (!selectedRows || selectedRows.length === 0) {
      return toast.info("Please select at least one room to delete.");
    }

    const payload = {
      ManageRoomUpdation: selectedRows.map((roomId) => ({
        RoomId: roomId,
        RoomTypeId: 0,
        RoomViewId: 0,
        SqFt: 0,
        MonthlyRent: 0,
        TotalBeds: 0,
        Flag: "",
        DBFLAG: "D",
      })),
    };
    let json = JSON.stringify(payload);

    json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    json = '"' + json + '"';

    try {
      const response = await deleteRoomMst(json);

      if (response instanceof Error) {
        return toast.error("Error: Could not delete rooms");
      }

      const {
        data: { Status, Message },
      } = response;

      if (Status === 0) {
        toast.success("Rooms deleted successfully");

        // Refresh the room data
        await getRoomMasterData();
        refreshRoomData();
        setIsModalOpen(false);
        // Reset form states
        setFormData({
          RoomTypeId: "",
          RoomViewId: "",
          SqFt: "",
          MonthlyRent: "",
          TotalBeds: "",
        });
        setSelectedRows([]);
        setSelectAll(false);
        setSearchTerms(
          columns.reduce((acc, current) => {
            acc[current.id] = "";
            return acc;
          }, {})
        );
      } else {
        toast.error(Message || "Failed to delete rooms");
      }
    } catch (error) {
      console.error("Delete operation failed:", error);
      toast.error("Failed to delete rooms");
    }
  };

  const getRoomMasterData = async () => {
    if (!PropId) {
      console.warn("PropId is required");
      setRows([]);
      return;
    }

    try {
      const response = await getRoomMaster({
        start: 1,
        PageSize: 1,
        SearchText: PropId.toString(),
      });

      if (response instanceof Error) {
        setRows([]);
        return toast.error(response.message || "");
      }

      const { data: { Status, Data } } = response;

      if (Status === 0) {
        setRows(Data);
      } else {
        setRows([]);
      }
    } catch (error) {
      setRows([]);
    }
  };

  useEffect(() => {
    if (PropId) {
      getRoomMasterData();
    } else {
      setRows([]);
    }
  }, [PropId]);

  const handleRowSelect = (rowId) => {
    console.log("rowId", rowId);
    const updatedSelectedRows = selectedRows.includes(rowId)
      ? selectedRows.filter((id) => id !== rowId)
      : [...selectedRows, rowId];
    setSelectedRows(updatedSelectedRows);

    // Update "Select All" checkbox state
    if (updatedSelectedRows.length === rows.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleSelectAll = (event) => {
    const newSelectAll = event.target.checked;
    setSelectAll(newSelectAll);

    const updatedSelectedRows = newSelectAll
      ? filteredRows.map((row) => row.RoomId)
      : [];
    setSelectedRows(updatedSelectedRows);
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms((prev) => ({ ...prev, [columnId]: value }));
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter((row) => {
      const matchesSearchTerms = Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
      const matchesRoomTypeFilter = filterNullRoomTypeName
        ? !row.RoomTypeName || row.RoomTypeName.trim() === ''
        : true;

      // Apply RoomViewNAme filter logic
      const matchesRoomViewFilter = filterNullRoomView
        ? !row.RoomViewNAme || row.RoomViewNAme.trim() === ''
        : true;

      // Apply SqFt filter logic
      const matchesSqFtFilter = filterNullSqFt
        ? !row.SqFt || row.SqFt === 0
        : true;

      // Apply TotalBeds filter logic
      const matchesTotalBedsFilter = filterNullTotalBeds
        ? !row.TotalBeds || row.TotalBeds === 0
        : true;

      // Apply MonthlyRent filter logic
      const matchesMonthlyRentFilter = filterNullMonthlyRent
        ? !row.MonthlyRent || row.MonthlyRent === 0
        : true;

      return (
        matchesSearchTerms &&
        matchesRoomTypeFilter &&
        matchesRoomViewFilter &&
        matchesSqFtFilter &&
        matchesTotalBedsFilter &&
        matchesMonthlyRentFilter
      );
    });
  }, [
    searchTerms,
    rows,
    filterNullRoomTypeName,
    filterNullRoomView,
    filterNullSqFt,
    filterNullTotalBeds,
    filterNullMonthlyRent,
  ]);

  const handleUpdate = async () => {
    if (!selectedRows || selectedRows.length < 1) {
      return toast.info("Select at least one row.")
    }

    if (!formData.RoomTypeId && !formData.RoomViewId) {
      return toast.info("Fill at least one of room type or room view.")
    }

    let json = JSON.stringify(getSubmitPayload());
    json = json.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    json = '"' + json + '"';

    const response = await manageRoomUpdation(json);

    if (response instanceof Error) {
      return toast.error("Error: Could not update form");
    }

    const { data: { Status, responseStatusCode, Message } } = response;

    if (Status === 0) {
      getRoomMasterData();
      setFormData({
        RoomTypeId: "",
        RoomViewId: "",
        SqFt: "",
        MonthlyRent: "",
        TotalBeds: "",
      });
      setSelectedRows([]);
      setSelectAll(false);
      setSearchTerms(
        columns.reduce((acc, current) => {
          acc[current.id] = "";
          return acc;
        }, {})
      );
      toast.success("Update Successfully", Message);

    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    loadRoomViewData();
  };

  return (
    // <Grid item xs={12} md={2} lg={6}>
    <Grid item>
      {/* <ToastContainer /> */}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleOpenModal}
        sx={{
          background: '#635bff',
          color: 'white',
          borderRadius: '50px',
          padding: '6px 15px',
          boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.3)',
          transition: 'background 0.3s ease',
          "&:hover": {
            background: "#524ccc"
          }
        }}
      >
        Room Configuration
      </Button>
      <Dialog
        open={isModalOpen}
        maxWidth="lg"
        fullWidth={true}
        sx={{
          "& .MuiDialogContent-root": {
            maxHeight: "80vh",
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="title" fontWeight="bold">
              Room Data Updation
            </Typography>
            <CancelPresentationIcon
              variant="contained"
              size="small"
              colour="primary"
              onClick={() => setIsModalOpen(false)}
            />
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBlock: "4px", paddingInline: "20px" }}>
          <Grid item lg={12} md={12} xs={12}>
            <Box display="flex" flexDirection="column" gap={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3} className="form_field">
                  <FormControl
                    variant="filled"
                    fullWidth
                    className="custom-select"
                  >
                    <InputLabel id="roomType-select-label">
                      Room Type
                    </InputLabel>
                    <Select
                      labelId="roomType-select-label"
                      id="roomType-select"
                      name="RoomTypeId"
                      value={formData.RoomTypeId}
                      onChange={handleInputChange}
                      className="custom-textfield"
                    >
                      {roomType.map((roomtype) => {
                        return (
                          <MenuItem key={roomtype.Id} value={roomtype.Id}>
                            {roomtype.Name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3} className="form_field">
                  <FormControl
                    variant="filled"
                    fullWidth
                    className="custom-select"
                  >
                    <InputLabel id="property-select-label">
                      Room View
                    </InputLabel>
                    <Select
                      labelId="property-select-label"
                      id="property-select"
                      name="RoomViewId"
                      value={formData.RoomViewId}
                      onChange={handleInputChange}
                      className="custom-textfield"
                    >
                      {roomView.map((roomview) => {
                        return (
                          <MenuItem key={roomview.Id} value={roomview.Id}>
                            {roomview.Name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="SqFt"
                    name="SqFt"
                    value={formData.SqFt}
                    onChange={handleInputChange}
                    variant="filled"
                    className="custom-textfield"
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="Rent"
                    name="MonthlyRent"
                    value={formData.MonthlyRent}
                    onChange={handleInputChange}
                    variant="filled"
                    className="custom-textfield"
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    fullWidth
                    label="Total Beds"
                    name="TotalBeds"
                    value={formData.TotalBeds}
                    onChange={handleInputChange}
                    variant="filled"
                    className="custom-textfield"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Paper
            sx={{
              maxWidth: "100%",
              overflow: "hidden",
              margin: "10px 0px 0px 0px",
              border: "1px solid lightgray",
            }}
          >
            <TableContainer sx={{ maxHeight: 360 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow
                    sx={{
                      "& > th": {
                        padding: "2px 10px 2px 10px",
                      },
                    }}
                  >
                    <TableCell padding="checkbox" style={{ width: 80, textAlign: "center" }}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        All
                      </Typography>
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          {typeof column.label === 'function' ? column.label() : column.label}
                        </Typography>
                        <TextField
                          size="small"
                          variant="outlined"
                          placeholder={`Search ${typeof column.label === 'function' ? column.id : column.label}`}
                          value={searchTerms[column.id]}
                          onChange={(e) => handleSearchChange(column.id, e.target.value)}
                          sx={{
                            mt: 1,
                            margin: "0px",
                            "& .MuiOutlinedInput-input": {
                              padding: "2px 2px",
                            },
                          }}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows.length > 0 ? (
                    filteredRows.map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.RoomId}
                        style={{ cursor: "pointer" }}
                        sx={{
                          "& > td": {
                            padding: "2px  14px 2px  19px",
                          },
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedRows.includes(row.RoomId)}
                            onChange={() => handleRowSelect(row.RoomId)}
                          />
                        </TableCell>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length + 1} align="center">
                        <Typography variant="body1" color="textSecondary">
                          No records found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>

              </Table>
            </TableContainer>
          </Paper>
        </DialogContent>
        <DialogActions sx={{ margin: " 0px 0px 0px 0px" }}>
          <Button
            variant="contained"
            onClick={handleGenerateRooms}
            color="primary"
          >
            Generate Rooms
          </Button>
          <Button variant="contained" color="primary" onClick={handleUpdate}>
            Update Rooms
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            disabled={!PropId}
          >
            Delete Rooms
          </Button>

        </DialogActions>
      </Dialog>
    </Grid>
  );
}